module.exports = __webpack_public_path__ + "img/1024.e4a3c5f9.svg";